// extracted by mini-css-extract-plugin
module.exports = {"title":"Tooltip_title__3_yYZ","title__bulb":"Tooltip_title__bulb__3RKWT","tips":"Tooltip_tips__PDRJw","dismiss":"Tooltip_dismiss__2Vduv"};